import styles from "./SummaryPanelButtons.module.css";

interface ISummaryPanelConsultationDropdownProps {
    currentLookupId?: string;
    handleContextTypeChanged?: (consultationContextLookupId?: string) => void;
}

function SummaryPanelConsultationDropdown(props: ISummaryPanelConsultationDropdownProps): JSX.Element {
    const availableConsultationContextList = cacheStore.FindLookupsByTypeCode("CONSULTATIONCONTEXT");

    return (
        <div className={`${styles.consultationContextSelectWrapper} margin-right-15px`}>
            <div>
                <div>
                    <strong
                        className="margin-none-bottom"
                        data-cy="medical-note-consultation-context-title"
                    >{cacheStore.GetString("ContextDLabel")}
                    </strong>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <select
                        data-cy="medical-note-consultation-context-dropdown"
                        onChange={e => props?.handleContextTypeChanged(e.target.value)}
                        className="form-control myle-control"
                        value={props?.currentLookupId}
                    >
                        {availableConsultationContextList.map((type, i) =>
                            <option key={i} value={type.LookupID}>{type.GetValue ? type.GetValue() : ""}</option>
                        )}
                    </select>
                </div>
            </div>
        </div>
    );
}

export { SummaryPanelConsultationDropdown };
